import { baseAxios, errorHandler } from "../index";
import Swal from "sweetalert2";
import moment from "moment";

export function getAreaNonGroup(dispatch) {
  baseAxios
    .get("/lokasi/getcategoryarea", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      console.log(respon);
      dispatch({
        type: "SET_LISTAREA",
        data: respon.data,
      });
      Swal.close();
    })
    .catch(errorHandler);
}
export function getTimeLine(dispatch, data) {
  baseAxios
    .get(`/keluhan/gettimeline?id=${data}`, {})
    .then(async (respon) => {
      dispatch({
        type: "SET_TIMELINE",
        data: respon.data,
      });
    })
    .catch(errorHandler);
}
export function daftarlokasi(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    timer: 2000,
    showConfirmButton: false,
  });
  baseAxios
    .post("/lokasi/daftargedung", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function daftarruangan(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .post("/lokasi/daftarruangan", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function editKodeRuangan(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .patch("/lokasi/editkoderuangan", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getShift(dispatch) {
  baseAxios
    .get("/shift/getshiftall", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_JAMLAPORAN", data: respon.data });
    })
    .catch(errorHandler);
}

export function daftarShift(data) {
  // var data = {
  //   jam: "[12, 13, 14]",
  //   durasi: "2",
  // };
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .post("/shift/daftarShift", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}
export function deleteShift(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .delete("/shift/deleteshift", {
      data: { _id: data },
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}
export function deleteGedung(data) {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      // console.log(data.visitId);
      baseAxios
        .delete("/lokasi/deletegedung", {
          data: { gedungId: data },
          headers: { token: localStorage.getItem("tokenjti") },
        })
        .then(async (respon) => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              window.location.reload();
            },
          );
        })
        .catch(errorHandler);

      // Swal.fire("Deleted!", "Your file has been deleted.", "success");
    }
  });
  // Swal.fire({
  //   title: "Tunggu ...",
  //   didOpen() {
  //     Swal.showLoading();
  //   },
  //   allowOutsideClick: false,
  //   allowEscapeKey: false,
  //   allowEnterKey: false,
  // });
  // baseAxios
  //   .delete("/lokasi/deletegedung", {
  //     data: { gedungId: data },
  //     headers: { token: localStorage.getItem("tokenjti") },
  //   })
  //   .then(async (respon) => {
  //     Swal.fire({
  //       title: respon.data.message,
  //       icon: "success",
  //     }).then(() => {
  //       window.location.reload();
  //     });
  //   })
  //   .catch(errorHandler);
}

export function deleteRuang(data) {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      // console.log(data.visitId);
      baseAxios
        .delete("/lokasi/deletearea", {
          data: { ruanganId: data },
          headers: { token: localStorage.getItem("tokenjti") },
        })
        .then(async (respon) => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              window.location.reload();
            },
          );
        })
        .catch(errorHandler);

      // Swal.fire("Deleted!", "Your file has been deleted.", "success");
    }
  });

  // Swal.fire({
  //   title: "Tunggu ...",
  //   didOpen() {
  //     Swal.showLoading();
  //   },
  //   allowOutsideClick: false,
  //   allowEscapeKey: false,
  //   allowEnterKey: false,
  // });
  // baseAxios
  //   .delete("/lokasi/deletearea", {
  //     data: { ruanganId: data },
  //     headers: { token: localStorage.getItem("tokenjti") },
  //   })
  //   .then(async (respon) => {
  //     Swal.fire({
  //       title: respon.data.message,
  //       icon: "success",
  //     }).then(() => {
  //       window.location.reload();
  //     });
  //   })
  //   .catch(errorHandler);
}

export function getLaporanRekap(dispatch, data) {
  baseAxios
    .get(
      `/laporan/historylaporan?tglmulai=${data.mulai}&tglselesai=${data.selesai}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    )
    .then(async (respon) => {
      dispatch({ type: "SET_LISTLAPORAN", data: respon.data });
    })
    .catch(errorHandler);
}

export function laporkanSelesai(data) {
  baseAxios
    .post(`/laporan/laporanselesai`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getvisittotalhariini(dispatch) {
  baseAxios
    .get(`/laporan/getvisithariini`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_TOTALVISITHARIINI", data: respon.data });
    })
    .catch(errorHandler);
}

export function getvisitproblemtotal(dispatch) {
  baseAxios
    .get(`/laporan/getvisitproblem`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_TOTALPROBLEM", data: respon.data });
    })
    .catch(errorHandler);
}

export function getKpiMonitoringProblem(dispatch, data) {
  baseAxios
    .get(
      `/laporan/pelaporankebersihan?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
      // `/laporan/getkpimonitoring1?tglmulai=${data.mulai}&tglselesai=${data.selesai}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    )
    .then((respon) => {
      dispatch({ type: "SET_KPI1", data: respon.data });
    })
    .catch(errorHandler);
}

export function deleteLaporanKunjungan(data) {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      // console.log(data.visitId);
      baseAxios
        .delete("/laporan/deletlaporan", {
          data: { laporanId: data },
          headers: { token: localStorage.getItem("tokenjti") },
        })
        .then(async (respon) => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              window.location.reload();
            },
          );
        })
        .catch(errorHandler);
    }
  });
}

export function getKpiMonitoringKeluhan(dispatch, data) {
  baseAxios
    .get(`/keluhan/keluhangrafik?dari=${data.dariTgl}&sampai=${data.smpTgl}`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_KPI2", data: respon.data });
    })
    .catch(errorHandler);
}

export function getKpiMonitoringProject(dispatch, data) {
  baseAxios
    .get(
      `/project/getprojectgrafik?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    )
    .then(async (respon) => {
      dispatch({ type: "SET_KPI4", data: respon.data });
    })
    .catch(errorHandler);
}

export function getKpiMonitoringKunjungan(dispatch, data) {
  baseAxios
    .get(
      `/laporan/getgrafikkunjungan?dari=${data.dariTgl}&sampai=${data.smpTgl}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    )
    .then(async (respon) => {
      dispatch({ type: "SET_KPI3", data: respon.data });
    })
    .catch(errorHandler);
}

export function exportBandU(data) {
  baseAxios
    .get(`/laporan/getexportbandu?dari=${data.dariTgl}&sampai=${data.smpTgl}`, {
      headers: { token: localStorage.getItem("tokenjti") },
      responseType: "blob",
    })
    .then(async (respon) => {
      // console.log(respon);
      const url = window.URL.createObjectURL(new Blob([respon.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `B&U ${moment(data.dariTgl).format("DD MMM YYYY")}-${moment(
          data.smpTgl,
        ).format("DD MMM YYYY")}.xlsx`,
      );
      document.body.appendChild(link);
      link.click();
      Swal.close();
    })
    .catch(errorHandler);
}

export function getRekapProblem(dispatch) {
  baseAxios
    .get("/laporan/rekapproblem", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_REKAPPROBLEM", data: respon.data });
    })
    .catch(errorHandler);
}

export async function getRekapLaporan(dispatch, data) {
  try {
    let response = await baseAxios.get(
      `/laporan/getrekaplaporan?page=${data.page}&limit=${data.limit}&search=${data.cari}&dariTgl=${data.dariTgl}&smpTgl=${data.smpTgl}&shift=${data.shift}&status=${data.namaStatus}&kondisi=${data.kondisi}`,
      {
        headers: { token: localStorage.getItem("tokenjti") },
      },
    );
    dispatch({ type: "SET_REKAPLAPORAN", data: response.data });
    return response.status;
  } catch (error) {
    return error.response;
  }
}

export function getRekapKeluhan(dispatch) {
  baseAxios
    .get("/keluhan/getkeluhanall", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_REKAPKELUHAN", data: respon.data });
    })
    .catch(errorHandler);
}

// Project
export function daftarKategoriProject(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .post("/project/daftarprojectkategory", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getKategori(dispatch) {
  baseAxios
    .get("/project/getprojectkategory", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_LISTKATEGORI", data: respon.data });
    })
    .catch(errorHandler);
}

export function pengajuanProject(data) {
  baseAxios
    .post(`/project/ajukanproject`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function verifikasiProject(data) {
  baseAxios
    .patch(`/project/responproject`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getProjectAll(dispatch) {
  baseAxios
    .get(`/project/getprojectall`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_PROJECTALL", data: respon.data });
    })
    .catch(errorHandler);
}

export function downloadFile(data) {
  baseAxios
    .get(`/project/downloaddokumen?file=` + data, {
      responseType: "blob",
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      const url = window.URL.createObjectURL(new Blob([respon.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", data);
      document.body.appendChild(link);
      link.click();
    })
    .catch(errorHandler);
}

export function kirimKeluhan(data) {
  if (!data.nama || !data.noHp || !data.deskripsi) {
    Swal.fire({
      title: "Harap lengkapi form terlebih dahulu",
      icon: "error",
    });
  } else {
    Swal.fire({
      title: "Loading ...",
      didOpen() {
        Swal.showLoading();
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
    });
    let formData = new FormData();

    formData.append("nama", data.nama);
    formData.append("noHp", data.noHp);
    formData.append("koderuangan", data.kode);
    formData.append("deskripsi", data.deskripsi);
    data.gambar.map((val, index) => {
      formData.append("dokumentasiAwalArr", val);
    });
    baseAxios
      .post(`/keluhan/daftarkeluhanbakalan`, formData, {
        headers: { token: localStorage.getItem("tokenjti") },
      })
      .then(async (respon) => {
        Swal.fire({
          title: respon.data.message,
          icon: "success",
        }).then(() => {
          window.location.reload();
        });
      })
      .catch(errorHandler);
  }
}
export function downloadPDF(data, ruangan) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .get(`/lokasi/getpdfruangan?ruanganId=${data}`, {
      headers: { token: localStorage.getItem("tokenjti") },
      responseType: "blob",
    })
    .then(async (respon) => {
      Swal.close();
      const file = new Blob([respon.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `QR${ruangan}.pdf`); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch(errorHandler);
}
export function downloadQR(data, ruangan) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .get(`/lokasi/getqrruangan?ruanganId=${data}`, {
      headers: { token: localStorage.getItem("tokenjti") },
      responseType: "blob",
    })
    .then(async (respon) => {
      Swal.close();
      const file = new Blob([respon.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `QR${ruangan}.pdf`); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch(errorHandler);
}

export function getCalendar(dispatch) {
  baseAxios
    .get("/project/getprojectcalendar", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_CALENDAR", data: respon.data });
    })
    .catch(errorHandler);
}

export function assignRoomToShift(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .patch("/shift/assignshifttoroom", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getProposal(dispatch) {
  baseAxios
    .get(`/proposal/getproposal`, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_PROPOSAL", data: respon.data });
    })
    .catch(errorHandler);
}

export function verifikasiProposal(data) {
  baseAxios
    .patch(`/proposal/responproposal`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function daftarHariLibur(data) {
  // console.log(">>>>>>>>>>>>.", data);
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .post("/shift/addevent", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export function getCalendarPatroli(dispatch) {
  baseAxios
    .get("/shift/getevent", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_CALENDARPATROLI", data: respon.data });
    })
    .catch(errorHandler);
}
export function deletedJadwalPatroli(data) {
  Swal.fire({
    title: `Are you sure delete ${data.nama}?`,
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      // console.log(data.visitId);
      baseAxios
        .delete("/shift/deletejadwallibur", {
          data: { idJadwal: data },
          headers: { token: localStorage.getItem("tokenjti") },
        })
        .then(async (respon) => {
          Swal.fire("Deleted!", "Your file has been deleted.", "success").then(
            () => {
              window.location.reload();
            },
          );
        })
        .catch(errorHandler);
    }
  });
}

export function getPatrol(dispatch) {
  baseAxios
    .get("/shift/getwaktupatroli", {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      dispatch({ type: "SET_JAMPATROLI", data: respon.data });
    })
    .catch(errorHandler);
}

export function downloadQRAll(data, ruangan) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
  });
  baseAxios
    .get(`/lokasi/getqrruanganall`, {
      headers: { token: localStorage.getItem("tokenjti") },
      responseType: "blob",
    })
    .then(async (respon) => {
      Swal.close();
      const file = new Blob([respon.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(file);
      // window.open(url);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `QR${ruangan}.pdf`); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch(errorHandler);
}

export function responPatrol(data) {
  Swal.fire({
    title: "Loading ...",
    didOpen() {
      Swal.showLoading();
    },
    allowOutsideClick: false,
    allowEscapeKey: false,
    allowEnterKey: false,
    timer: 2000,
    showConfirmButton: false,
  });
  baseAxios
    .post("/laporan/persetujuanPatrol", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    })
    .then(async (respon) => {
      Swal.fire({
        title: respon.data.message,
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    })
    .catch(errorHandler);
}

export async function addWaktuPatrol(data) {
  try {
    const response = await baseAxios.post("/shift/createwaktupatroli", data, {
      headers: {
        token: localStorage.getItem("tokenjti"),
      },
    });
    return response;
  } catch (err) {
    return err.response;
  }
}
export async function editWaktuPatrol(data) {
  try {
    const response = await baseAxios.patch("/shift/editwaktupatroli", data, {
      headers: {
        token: localStorage.getItem("tokenjti"),
      },
    });
    return response;
  } catch (err) {
    return err.response;
  }
}

export async function updateStatusPatrol(data) {
  try {
    let response = await baseAxios.patch(`/laporan/updatestatuspatrol`, data, {
      headers: { token: localStorage.getItem("tokenjti") },
    });
    return response;
  } catch (error) {
    return error.response;
  }
}

export async function getExportPatrol(data) {
  // 1️⃣ Konfirmasi
  const confirm = await Swal.fire({
    title: "Export Data",
    text: `Export data dari ${moment(data.tglAwal).format(
      "DD MMM YYYY",
    )} sampai ${moment(data.tglAkhir).format("DD MMM YYYY")}?`,
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Ya, Export",
    cancelButtonText: "Batal",
  });

  if (!confirm.isConfirmed) return;

  try {
    // 2️⃣ START EXPORT
    const start = await baseAxios.post("/laporan/exportPatrol", data, {
      headers: { token: localStorage.getItem("tokenjti") },
    });

    const jobId = start.data.jobId;

    // 3️⃣ MODAL PROGRESS
    Swal.fire({
      title: "Preparing file...",
      html: `
        <div style="margin-top:10px">
          <div style="
            width:100%;
            background:#eee;
            border-radius:4px;
            overflow:hidden">
            <div id="progress-bar" style="
              height:14px;
              width:0%;
              background:#3085d6;
              transition:width .3s">
            </div>
          </div>
          <b id="progress-text">0%</b>
        </div>
      `,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        const timer = setInterval(async () => {
          try {
            // 4️⃣ CEK PROGRESS
            const res = await baseAxios.get(
              `/laporan/exportprogress/${jobId}`,
              {
                headers: { token: localStorage.getItem("tokenjti") },
              },
            );

            const { progress, status } = res.data;

            const bar = document.getElementById("progress-bar");
            const text = document.getElementById("progress-text");

            if (bar) bar.style.width = `${progress}%`;
            if (text) text.innerText = `${progress}%`;

            // 5️⃣ SELESAI → DOWNLOAD
            if (status === "done" && progress === 100) {
              clearInterval(timer);
              Swal.close();

              // 🔥 Trigger download
              const response = await baseAxios.get(
                `/laporan/exportdownload/${jobId}`,
                {
                  headers: {
                    token: localStorage.getItem("tokenjti"),
                  },
                  responseType: "blob",
                },
              );

              // bikin file
              const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });

              const url = window.URL.createObjectURL(blob);

              const a = document.createElement("a");
              a.href = url;
              a.download = `Data Patrol ${moment(data.tglAwal).format(
                "DD MMMM YYYY",
              )}-${moment(data.tglAkhir).format("DD MMMM YYYY")}.xlsx`;
              document.body.appendChild(a);
              a.click();

              a.remove();
              window.URL.revokeObjectURL(url);

              Swal.fire({
                icon: "success",
                title: "Export selesai",
                text: "File berhasil diunduh",
                timer: 1500,
                showConfirmButton: false,
              });
            }

            // ❌ ERROR
            if (status === "error") {
              clearInterval(timer);
              Swal.fire({
                icon: "error",
                title: "Export gagal",
                text: "Terjadi kesalahan saat export",
              });
            }
          } catch (err) {
            clearInterval(timer);
            Swal.fire({
              icon: "error",
              title: "Export gagal",
              text: err?.message || "Tidak bisa mengambil progress",
            });
          }
        }, 1000);
      },
    });
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "Export gagal",
      text: err?.message || "Tidak bisa memulai export",
    });
  }
}

// export async function getExportPatrol(data) {
//   Swal.fire({
//     title: "Confirm Export",
//     text: `Are you sure you want to export data patrol from ${moment(
//       data.tglAwal
//     ).format("DD MMMM YYYY")} to ${moment(data.tglAkhir).format(
//       "DD MMMM YYYY"
//     )} ?`,
//     icon: "question",
//     showCancelButton: true,
//     confirmButtonText: "Yes, Export",
//     cancelButtonText: "Cancel",
//     allowOutsideClick: () => !Swal.isLoading(),
//     showLoaderOnConfirm: true,
//     preConfirm: () => {
//       return new Promise((resolve) => {
//         baseAxios
//           .get(
//             `/laporan/exportpatrol?tglAwal=${data.tglAwal}&tglAkhir=${data.tglAkhir}`,
//             {
//               headers: { token: localStorage.getItem("tokenjti") },
//               responseType: "blob",
//             }
//           )
//           .then((respon) => {
//             // console.log(respon, "KKKK");
//             const url = window.URL.createObjectURL(new Blob([respon.data]));
//             const link = document.createElement("a");
//             link.href = url;
//             link.setAttribute(
//               "download",
//               `Data Patrol ${moment(data.tglAwal).format(
//                 "DD MMMM YYYY"
//               )}-${moment(data.tglAkhir).format("DD MMMM YYYY")}.xlsx`
//             );
//             document.body.appendChild(link);
//             link.click();
//             Swal.close();
//             Swal.fire({
//               icon: "success",
//               title: "Export Success",
//               text: "Data successfully exported.",
//             });
//             resolve();
//           })
//           .catch((err) => {
//             console.log(err, "ERR");
//             Swal.showValidationMessage(`Failed export data: ${err}`);
//             resolve();
//           });
//       });
//     },
//   });
// }
